import { IgNudgeAlert } from "@intelligems/ig-theme/IgNudgeAlert";

import type { BillingStatusContent } from "@src/components/MainApp/Alerts/useBillingStatusContent";

type TrialSalesNudgeViewProps = {
  content: BillingStatusContent;
  onBookSalesCall: () => void;
  onDismiss: (() => void) | undefined;
};

export const TrialSalesNudgeView = ({
  content,
  onBookSalesCall,
  onDismiss,
}: TrialSalesNudgeViewProps) => (
  <IgNudgeAlert
    title={content.cardMessage}
    description={content.secondaryText}
    action={
      content.cta
        ? {
            label: content.cta,
            onClick: onBookSalesCall,
            variant: content.buttonVariant,
            color: content.buttonColor,
          }
        : undefined
    }
    onDismiss={onDismiss}
    dismissAriaLabel="Dismiss sales call notice"
  />
);
